import React from 'react';
import useSidePanel from 'Hooks/reduxHelperHooks/useSidePanel';
import { SidePanelButton } from '@brighterion/br-ui';
import { handleKeyEvent, handleOnClickEvent } from 'Utils';
import { RoleService } from 'Services';
import { shouldShowListImportExport } from 'Selectors';

const ImportExportQueue = () => {
    const { openImportExportQueue } = useSidePanel();
    const shouldShowSidePanelButton = shouldShowListImportExport() && RoleService.hasListAccess;

    const openQueueSidePanel = () => {
        openImportExportQueue();
    };

    return (
        <>
            {shouldShowSidePanelButton && (
                <SidePanelButton
                    iconName='cloud-arrow-down-outline'
                    color='primary'
                    onKeyDown={handleKeyEvent(openQueueSidePanel)}
                    onClick={handleOnClickEvent(openQueueSidePanel)}
                />
            )}
        </>
    );
};

export default ImportExportQueue;
